





import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PreambleComponent extends Vue {
  @Prop({
      default: null
    })
    public content: string;
}

